import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { wait } from 'Src/me/pages/guest/proposals/new/utils';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { NonInteractiveContinueHandlerType, FeaturePropsType } from '../../../../../chat/views/types';
import type { RenderUserMessagePropsType } from '../../../../../chat/views/UserMessage/index';
import { scrollToBottomOfChat } from '../../../../../chat/functional/scrollToBottomOfChat';
import { UserChatBubble } from './components/UserChatBubble';

const { tablet, mobile } = mediaQueries();

export type UserMessagePropsType = FeaturePropsType<RenderUserMessagePropsType & {
  isFirstElement: boolean;
  isConsecutive: boolean;
}, NonInteractiveContinueHandlerType>

export const UserMessage = (props: UserMessagePropsType) => {
  const {
    doesNotScroll,
    continueHandler,
    isInstant = false,
    isConsecutive,
  } = props;
  const [isLoading, setIsLoading] = React.useState(!isInstant);
  const [isReaded, setIsReaded] = React.useState(isInstant);

  React.useEffect(() => {
    (async () => {
      if (!isInstant) {
        await wait(1);

        setIsLoading(false);

        await wait(0.6);

        setIsReaded(true);

        await wait(1);
      }

      // 次に進む
      continueHandler({
        selfDomReferences: [],
      });
    })();
  }, [isInstant, continueHandler]);

  React.useEffect(() => {
    if (!doesNotScroll) scrollToBottomOfChat();
  }, [doesNotScroll]);

  return (
    <div
      css={css`
        padding-top: ${isConsecutive ? '10px' : '30px'};
        padding-right: 7px;

        ${mobile(() => css`
          padding-left: 12px;
          padding-right: 19px;
        `)}
      `}
    >
      <div
        css={css`
          display: grid;
          justify-items: end;
          align-items: end;
          grid-template-columns: 1fr auto;
          gap: 0 4px;
          max-width: calc(100% - 100px);
          margin-left: auto;

          ${mobile(() => css`
            max-width: 90%;
          `)}
        `}
      >
        <p
          css={css`
            color: #000;
            font-size: 15px;
            visibility: hidden;
            white-space: nowrap;

            ${mobile(({ clamp }) => css`
              font-size: ${clamp('10px', '14px')};
            `)}

            ${isReaded && css`
              visibility: visible;
            `}
          `}
        >
          既読
        </p>
        <UserChatBubble {...props} isLoading={isLoading} />
      </div>
    </div>
  );
};
